import { create } from 'zustand';
import { authApi } from '../api/auth';
import type { AdminUser, LoginRequest } from '../types';

interface AuthState {
  user: AdminUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;

  login: (credentials: LoginRequest) => Promise<void>;
  logout: () => Promise<void>;
  verifyAuth: () => Promise<void>;
  clearError: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  user: authApi.getCurrentUser(),
  isAuthenticated: !!authApi.getCurrentUser(),
  isLoading: false,
  error: null,

  login: async (credentials) => {
    set({ isLoading: true, error: null });
    try {
      const response = await authApi.login(credentials);
      authApi.saveAuth(response.access_token, response.user);
      set({
        user: response.user,
        isAuthenticated: true,
        isLoading: false
      });
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : 'Помилка авторизації',
        isLoading: false
      });
      throw error;
    }
  },

  logout: async () => {
    try {
      await authApi.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      set({
        user: null,
        isAuthenticated: false,
        error: null
      });
    }
  },

  verifyAuth: async () => {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      set({ isAuthenticated: false, user: null });
      return;
    }

    try {
      const user = await authApi.verifyToken();
      set({ user, isAuthenticated: true });
    } catch (error) {
      set({ isAuthenticated: false, user: null });
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    }
  },

  clearError: () => set({ error: null })
}));
